import React from 'react'

import Section from 'common/Section'
import SectionTitle from 'common/Section/title'

export default props => (
  <Section>
    <SectionTitle>Life at Style Theory</SectionTitle>
    <div className='flex flex-wrap flex-nowrap-ns'>
      <div className='dn db-ns flex-auto st-mr3-ns st-mb3-ns'>
        <img style={{ maxHeight: '442px' }} className='db' src='https://d2u7nrdrppwhsn.cloudfront.net/career/life_2018-05_a1.jpg' />
      </div>
      <div className='flex-auto mb2 st-mb3-ns'>
        <img style={{ maxHeight: '442px' }} className='db' src='https://d2u7nrdrppwhsn.cloudfront.net/career/id-jfw-2018.jpg' />
      </div>
    </div>
    <div className='flex flex-wrap flex-nowrap-ns'>
      <div className='dn-ns flex-auto pr1 mb2 w-50'>
        <img className='db' src='https://d2u7nrdrppwhsn.cloudfront.net/career/life_2018-05_b4.jpg' />
      </div>

      <div className='flex-auto pl1 pl0-ns st-pr3-ns mb2 st-mb3-ns w-50 w-auto-ns'>
        <img style={{ maxHeight: '480px' }} className='db' src='https://d2u7nrdrppwhsn.cloudfront.net/career/whoweare_2018-05_a1.jpg' />
      </div>
      <div className='flex-auto st-mr3-ns mb2 mb0-ns'>
        <img style={{ maxHeight: '480px' }} className='db' src='https://d2u7nrdrppwhsn.cloudfront.net/career/sg-capsule.jpg' />
      </div>
      <div className='flex-auto pr1 pr0-ns st-mb3-ns mb2 st-mb3-ns w-50 w-auto-ns'>
        <img style={{ maxHeight: '480px' }} className='db' src='https://d2u7nrdrppwhsn.cloudfront.net/career/sg-christmas-2018.jpg' />
      </div>

      <div className='dn-ns flex-auto pl1 mb2 w-50'>
        <img className='db' src='https://d2u7nrdrppwhsn.cloudfront.net/career/life_2018-05_b1.jpg' />
      </div>
    </div>
    <div className='flex flex-wrap flex-nowrap-ns'>
      <div className='flex-auto st-mr3-ns'>
        <img className='db' style={{ maxHeight: '442px' }} src='https://d2u7nrdrppwhsn.cloudfront.net/career/life_2018-05_c1.jpg' />
      </div>
      <div className='dn db-ns flex-auto'>
        <img className='db' src='https://d2u7nrdrppwhsn.cloudfront.net/career/life_2018-05_b1.jpg' />
      </div>
    </div>
  </Section>
)
